/**
 * TPL Option Slide — motion.dev "Smooth tabs" applied to the variant pills
 * (Size, Finish: fieldset.product-form__input--pill). One highlight pill glides
 * and resizes between choices; the checked label goes transparent above it.
 * Selection itself stays with Dawn's radios; this only follows :checked.
 */
(function () {
  'use strict';

  var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var MOVE_MS = 420;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function checkedLabel(fieldset) {
    var input = fieldset.querySelector('input[type="radio"]:checked');
    return input ? fieldset.querySelector('label[for="' + input.id + '"]') || input.nextElementSibling : null;
  }

  /* Measure against a 0x0 sentinel parked at the highlight's own origin, so
     fieldset/legend box quirks cannot skew the offsets. */
  function geometry(label, origin) {
    var lr = label.getBoundingClientRect(), o = origin.getBoundingClientRect();
    return { x: lr.left - o.left, y: lr.top - o.top, w: lr.width, h: lr.height };
  }

  function init(fieldset) {
    if (fieldset.dataset.tplSlide === '1') return;
    fieldset.dataset.tplSlide = '1';
    var origin = document.createElement('span');
    origin.className = 'tpl-pill-origin';
    origin.setAttribute('aria-hidden', 'true');
    var hl = document.createElement('span');
    hl.className = 'tpl-pill-hl';
    hl.setAttribute('aria-hidden', 'true');
    fieldset.appendChild(origin);
    fieldset.appendChild(hl);
    var current = null;

    function place(animate) {
      var label = checkedLabel(fieldset);
      if (!label) { hl.style.opacity = '0'; fieldset.classList.remove('has-pill-hl'); return; }
      fieldset.classList.add('has-pill-hl');
      var g = geometry(label, origin);
      var to = { transform: 'translate(' + g.x.toFixed(1) + 'px,' + g.y.toFixed(1) + 'px)', width: g.w.toFixed(1) + 'px', height: g.h.toFixed(1) + 'px', opacity: 1 };
      /* Write nothing when nothing moved: every style write is a mutation other
         observers on the page react to, and that cycle once storm-locked the PDP. */
      if (label === current && hl.style.transform === to.transform && hl.style.width === to.width && hl.style.height === to.height) return;
      if (animate && current && !reducedMotion() && typeof hl.animate === 'function') {
        var from = { transform: hl.style.transform || to.transform, width: hl.style.width || to.width, height: hl.style.height || to.height, opacity: 1 };
        hl.animate([from, to], { duration: MOVE_MS, easing: EXPO, fill: 'forwards' }).onfinish = function () {
          hl.style.transform = to.transform; hl.style.width = to.width; hl.style.height = to.height; hl.style.opacity = '1';
          hl.getAnimations().forEach(function (a) { a.cancel(); });
        };
      } else {
        hl.style.transform = to.transform; hl.style.width = to.width; hl.style.height = to.height; hl.style.opacity = '1';
      }
      current = label;
    }

    place(false);
    fieldset.addEventListener('change', function () { place(true); });
    /* Only the radios' own availability flips need a re-place; never react to
       class or style churn (that fed back into itself). Coalesced to one rAF. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; place(false); });
    }).observe(fieldset, { attributes: true, subtree: true, attributeFilter: ['disabled', 'checked'] });
    window.addEventListener('resize', function () { place(false); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { place(false); });
    /* The legend and the pills settle after boot (fonts, the size note, the
       buy box reflowing), which slid the labels out from under a highlight
       placed once. Re-place whenever the fieldset or any of its parts resize. */
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; place(false); });
      });
      ro.observe(fieldset);
      Array.prototype.forEach.call(fieldset.children, function (el) {
        if (el !== hl && el !== origin) ro.observe(el);
      });
    }
  }

  function boot() { document.querySelectorAll('fieldset.product-form__input--pill').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);

  window.TPLOptionSlide = { init: init, geometry: geometry, checkedLabel: checkedLabel };
})();
